import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Nura Health</title>
        <meta name="description" content="Nura Health terms of service for mobile pathology collection services across Brisbane, Sydney and Melbourne metros." />
        <link rel="canonical" href="https://nurahealth.com.au/terms" />
      </Helmet>
      <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
        <iframe
          src="/terms.html"
          style={{ width: '100%', height: '100%', border: 'none', margin: 0, padding: 0 }}
          title="Terms of Service"
        />
      </div>
    </>
  );
};

export default TermsPage;
